import { http } from './client';
import type {
  DiagnoseInput,
  DiagnoseResponse,
  FeedbackEscalateResponse,
  FeedbackSatisfiedResponse,
  Language,
  SupportInput,
  SupportResponse,
} from './types';

function langHeader(lang?: Language): Record<string, string> | undefined {
  return lang ? { 'Accept-Language': lang } : undefined;
}

export const actionsApi = {
  async diagnose(input: DiagnoseInput, lang?: Language): Promise<DiagnoseResponse> {
    const res = await http.post<DiagnoseResponse>('/v1/bot/diagnose', input, {
      headers: langHeader(lang),
    });
    return res.data;
  },
  async support(input: SupportInput, lang?: Language): Promise<SupportResponse> {
    const res = await http.post<SupportResponse>('/v1/bot/support', input, {
      headers: langHeader(lang),
    });
    return res.data;
  },
  async feedbackSatisfied(feedbackId: string): Promise<FeedbackSatisfiedResponse> {
    const res = await http.post<FeedbackSatisfiedResponse>(
      `/v1/bot/feedback/${encodeURIComponent(feedbackId)}/satisfied`,
    );
    return res.data;
  },
  async feedbackEscalate(
    feedbackId: string,
    body: { comment?: string; contactEmail?: string } = {},
  ): Promise<FeedbackEscalateResponse> {
    const res = await http.post<FeedbackEscalateResponse>(
      `/v1/bot/feedback/${encodeURIComponent(feedbackId)}/escalate`,
      body,
    );
    return res.data;
  },
};
